/* Ingredients accordion + FLIP image. Added by Oleg @ IAKOE.
   <ts-ingredients>, rows open/close (accordion). Closed rows are a fixed height;
   on open the head shrinks (thumb leaves the flow) so the title sits close to the
   image. The image flight is a GHOST clone positioned ABSOLUTE inside the row
   (item-relative coords, so page shifts during one-open don't desync it). The
   thumb's closed box is captured on open and reused on close, so the flight still
   works even though the thumb is display:none while open. On load the first row
   opens instantly, unless the URL hash targets a row (#ing-<handle>). Optional
   product filter pills. Respects prefers-reduced-motion (instant, no flight). */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 420; // ms
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  class TSIngredients extends HTMLElement {
    connectedCallback() {
      this.oneOpen = this.hasAttribute('data-one-open');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.ts-inglist__item'));
      this.items.forEach(this.bindItem.bind(this));
      this.bindFilter();
      this.markEdges();
      this.openInitial();
    }

    /* mark the first + last VISIBLE row (border rules key off these so the top
       line is dropped on whichever row is first, even while filtered) */
    markEdges() {
      // DOM order, not this.items: a product filter lifts its hero rows to the top
      var visible = Array.prototype.slice.call(this.querySelectorAll('.ts-inglist__item')).filter(function (it) { return !it.hidden; });
      this.items.forEach(function (it) { it.classList.remove('is-first', 'is-last'); });
      if (visible.length) {
        visible[0].classList.add('is-first');
        visible[visible.length - 1].classList.add('is-last');
      }
    }

    /* item-relative box of an element {left, top, width, height} */
    relRect(item, el) {
      var r = el.getBoundingClientRect();
      var ir = item.getBoundingClientRect();
      return { left: r.left - ir.left, top: r.top - ir.top, width: r.width, height: r.height };
    }

    openInitial() {
      var hash = location.hash ? location.hash.slice(1) : '';
      var target = null;
      if (hash) {
        this.items.forEach(function (item) {
          if (item.id === hash) target = item;
        });
      }
      if (!target) target = this.items[0];
      if (target) this.openInstant(target);
    }

    openInstant(item) {
      var head = item.querySelector('.ts-inglist__head');
      var panel = item.querySelector('.ts-inglist__panel');
      if (!head || !panel) return;
      item.classList.add('is-open');
      head.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = 'auto';
    }

    bindItem(item) {
      var head = item.querySelector('.ts-inglist__head');
      var panel = item.querySelector('.ts-inglist__panel');
      if (!head || !panel) return;
      head.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          this.close(item);
        } else {
          this.open(item);
        }
      }.bind(this));
    }

    open(item) {
      if (this.oneOpen) {
        this.items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) this.close(other);
        }.bind(this));
      }
      var head = item.querySelector('.ts-inglist__head');
      var panel = item.querySelector('.ts-inglist__panel');
      var thumb = item.querySelector('.ts-inglist__thumb');
      var media = item.querySelector('.ts-inglist__media');

      this.killGhost(item);
      this.clearPanelDone(item, panel); // drop any leaked listener from a prior anim
      // thumb box in the CLOSED layout (before is-open hides + shrinks the head)
      var thumbBox = thumb ? this.relRect(item, thumb) : null;
      if (thumbBox) item._thumbBox = thumbBox;

      item.classList.remove('is-closing');
      item.classList.add('is-open');
      head.setAttribute('aria-expanded', 'true');
      panel.hidden = false;

      if (REDUCED) {
        panel.style.height = 'auto';
        return;
      }

      var target = panel.scrollHeight;
      panel.style.height = '0px';
      // media box now that the head has shrunk (its final resting position)
      if (media && thumbBox && thumbBox.width) {
        var mediaBox = this.relRect(item, media);
        this.flyGhost(item, media, thumbBox, mediaBox);
      }
      panel.getBoundingClientRect();
      panel.style.transition = 'height ' + DURATION + 'ms ' + EASE;
      panel.style.height = target + 'px';
      var done = function (e) {
        if (e && (e.target !== panel || e.propertyName !== 'height')) return; // ignore bubbled/other props
        clearTimeout(item._panelTimer);
        panel.style.transition = '';
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', done);
        item._panelDone = null;
      };
      item._panelDone = done;
      panel.addEventListener('transitionend', done);
      item._panelTimer = setTimeout(done, DURATION + 80); // Safari/FF: transitionend may not fire
    }

    close(item) {
      var head = item.querySelector('.ts-inglist__head');
      var panel = item.querySelector('.ts-inglist__panel');
      var media = item.querySelector('.ts-inglist__media');

      head.setAttribute('aria-expanded', 'false');

      if (REDUCED) {
        item.classList.remove('is-open');
        panel.hidden = true;
        panel.style.height = '';
        return;
      }

      this.killGhost(item);
      this.clearPanelDone(item, panel); // drop any leaked listener from a prior anim
      // media at its open position (still item-relative); thumb target = stored closed box
      var mediaBox = media ? this.relRect(item, media) : null;
      var thumbBox = item._thumbBox;

      item.classList.add('is-closing');
      item.classList.remove('is-open'); // head grows back; thumb stays display:none via is-closing

      var start = panel.scrollHeight;
      panel.style.height = start + 'px';
      if (media && mediaBox && mediaBox.width && thumbBox && thumbBox.width) {
        this.flyGhost(item, media, mediaBox, thumbBox);
      } else {
        item.classList.remove('is-closing');
      }
      panel.getBoundingClientRect();
      panel.style.transition = 'height ' + DURATION + 'ms ' + EASE;
      panel.style.height = '0px';
      var done = function (e) {
        if (e && (e.target !== panel || e.propertyName !== 'height')) return; // ignore bubbled/other props
        clearTimeout(item._panelTimer);
        panel.style.transition = '';
        panel.style.height = '';
        panel.hidden = true;
        item.classList.remove('is-closing');
        panel.removeEventListener('transitionend', done);
        item._panelDone = null;
      };
      item._panelDone = done;
      panel.addEventListener('transitionend', done);
      item._panelTimer = setTimeout(done, DURATION + 80); // Safari/FF: transitionend may not fire
    }

    /* remove a leaked height-transition listener (e.g. when a row was hidden by
       the filter before its transition could fire) */
    clearPanelDone(item, panel) {
      clearTimeout(item._panelTimer);
      if (item._panelDone) {
        panel.removeEventListener('transitionend', item._panelDone);
        item._panelDone = null;
      }
    }

    /* instant close, no animation: used when the filter hides an open row (a
       display:none element never fires transitionend, so the animated close
       would leak its listener and later hide a freshly-opened panel) */
    reset(item) {
      var head = item.querySelector('.ts-inglist__head');
      var panel = item.querySelector('.ts-inglist__panel');
      this.clearPanelDone(item, panel);
      this.killGhost(item);
      item.classList.remove('is-open', 'is-closing');
      if (head) head.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.style.transition = '';
        panel.style.height = '';
        panel.hidden = true;
      }
    }

    /* one clone flies (item-relative, absolute inside the item), then the real
       image returns. from/to are {left, top, width, height} in item coords. */
    flyGhost(item, media, from, to) {
      var img = media.querySelector('img');
      if (!img) return;

      media.style.visibility = 'hidden';
      var ghost = img.cloneNode(false);
      ghost.setAttribute('aria-hidden', 'true');
      ghost.style.cssText =
        'position:absolute;margin:0;z-index:20;pointer-events:none;object-fit:contain;' +
        'left:' + from.left + 'px;top:' + from.top + 'px;' +
        'width:' + from.width + 'px;height:' + from.height + 'px;';
      item.appendChild(ghost);
      item._ghost = ghost;
      item._ghostMedia = media;

      ghost.getBoundingClientRect(); // commit the start box
      ghost.style.transition =
        'left ' + DURATION + 'ms ' + EASE + ', top ' + DURATION + 'ms ' + EASE +
        ', width ' + DURATION + 'ms ' + EASE + ', height ' + DURATION + 'ms ' + EASE;
      ghost.style.left = to.left + 'px';
      ghost.style.top = to.top + 'px';
      ghost.style.width = to.width + 'px';
      ghost.style.height = to.height + 'px';

      var self = this;
      var finish = function () {
        if (item._ghost === ghost) self.killGhost(item);
      };
      ghost.addEventListener('transitionend', finish);
      setTimeout(finish, DURATION + 100); // safety net if transitionend never fires
    }

    killGhost(item) {
      if (item._ghost && item._ghost.parentNode) {
        item._ghost.parentNode.removeChild(item._ghost);
      }
      item._ghost = null;
      if (item._ghostMedia) {
        item._ghostMedia.style.visibility = '';
        item._ghostMedia = null;
      }
      item.classList.remove('is-closing'); // thumb comes back when closed
    }

    bindFilter() {
      var pills = Array.prototype.slice.call(this.querySelectorAll('.ts-inglist__pill'));
      if (!pills.length) return;
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var val = pill.getAttribute('data-filter');
          pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
          this.applyFilter(val, pill.getAttribute('data-hero') || '');
        }.bind(this));
      }.bind(this));
    }

    /* Row order: the product's hero ingredients (data-hero on its pill, handles
       in order) go to the top while that product is active; any other filter
       puts every row back where Liquid rendered it (this.items keeps that
       order). Nodes are moved in place, never rebuilt, so open state and
       listeners survive. */
    reorder(heroes) {
      var list = this.items.length ? this.items[0].parentNode : null;
      if (!list) return;
      this.items.forEach(function (item) { list.appendChild(item); });
      var handles = heroes.split(/\s+/).filter(Boolean).reverse();
      handles.forEach(function (handle) {
        var row = list.querySelector('#ing-' + handle);
        if (row) list.insertBefore(row, list.firstElementChild);
      });
    }

    applyFilter(val, heroes) {
      this.reorder(val === 'all' ? '' : heroes || '');
      this.items.forEach(function (item) {
        var match = val === 'all' || (' ' + (item.getAttribute('data-products') || '') + ' ').indexOf(' ' + val + ' ') !== -1;
        // on any filter change, collapse every open/closing row (instant, so no
        // animation runs on a row that is about to be hidden)
        if (item.classList.contains('is-open') || item.classList.contains('is-closing')) {
          this.reset(item);
        }
        item.hidden = !match;
      }.bind(this));
      this.markEdges();
    }
  }

  if (!customElements.get('ts-ingredients')) {
    customElements.define('ts-ingredients', TSIngredients);
  }
})();
